import { Autocomplete, Box, IconButton ,TextField} from "@mui/material"
import { NewRemoveRoundIcon } from "../../../../../../core/global/GMicons"
import { IOSSwitch } from "../../../../../../core/global/forms/CstmToggle"


export const Fields = ({ match, ctgyForm, setCtgyForm, ctgyid, categoryType }) => {

    const handleInputCategory = (e, id, indx, type) => {
        const {name, value, checked} = e.target
        let fdata = [...ctgyForm]
        if (type === 'type') {
            ctgyForm[indx][type] = id
        }else{
            ctgyForm[indx][name] = name === 'categoryname' ? value : (checked ? 1 : 0)
        }
        setCtgyForm(fdata)
    }

    const handleRemoveRow = (e, index) => {
        let data = [...ctgyForm]
        data.splice(index, 1)
        data = data.map((v,k) => ({...v, category_num:`CTGRY-00000000${ctgyid + k + 1}`}))
        setCtgyForm(data)
    }

    return (
        ctgyForm.map((v,k) => (
            <Box key={k} width="100%" p={2} bgcolor="#FFFFFF" mt={2} borderRadius="10px" >
                <Box width="100%" display="block" flexDirection="row" >
                    <Box>
                        
                        <Box width="100%" fontSize="14px" fontWeight={600} >
                            <Box display='flex' justifyContent='space-between'> 
                                <Box  mb="8px" mt="10px">Category Number *</Box>
                                    {
                                        ctgyForm.length > 1 &&
                                            <Box sx={{display:'flex', justifyContent:'right'}}>
                                                <IconButton  sx={{ height: 30, width: 30,bgcolor: '#D8D5D5', '&:hover':{ backgroundColor: '#1B984F' },}} onClick={(e) => handleRemoveRow(e, k)}>
                                                    <NewRemoveRoundIcon />
                                                </IconButton>
                                            </Box>
                                    }
                            </Box>
                            <TextField fullWidth  sx={{"& .MuiOutlinedInput-root": {height: "40px"} ,}} disabled value={v.category_num}/>
                        </Box>

                        <Box fontSize="14px" fontWeight={600} lineHeight="16px" >
                            <Box  mb="8px" mt="10px">Category Name *</Box>
                            <TextField fullWidth  name="categoryname" sx={{"& .MuiOutlinedInput-root": {height: "40px"}}}
                            value={v.categoryname} error={Boolean(v.error)} helperText={v.error} onChange={(e) => handleInputCategory (e, v.id, k, '')} />
                        </Box>
                        
                         {/* sx={{ "& .MuiInputBase-root": {  height: 40, }, "& input": { fontSize: 14,   padding: "0px 14px", },}}  */}
                        <Box fontSize="14px" fontWeight={600} lineHeight="16px" >
                            <Box  mb="8px" mt="10px">Type of Concern *</Box>
                            <Autocomplete 
                                disablePortal
                                blurOnSelect
                                noOptionsText="No Result"
                                name="type"
                                autoHighlight={true}
                                options={categoryType}
                                getOptionLabel={(data) => (data.name)}
                                value={ctgyForm[k].type === '' ? null : categoryType.filter((f) => ctgyForm[k].type === f.id ? {...f} : null)[0]}
                                onChange={(e, value) => handleInputCategory (e, value ? value.id : null, k, 'type')}
                                renderInput={(params) => (
                                    <TextField  sx={{"& .MuiOutlinedInput-root": {height: "40px"},}} error={ctgyForm.type === null} {...params} inputProps={{...params.inputProps,autoComplete: 'off' ,sx:{ height: 12, p:0 ,'& input':{height:"10px",lineHeight:'12px', p:'0 12px'}}}} />
                                )}/>
                        </Box>
                        {
                        match.params === 'update' &&
                            <Box width="100%" display="flex" justifyContent="flex-end" gap={1} p="16px 16px 0px 16px">
                                <IOSSwitch name="active" value={ctgyForm.active} checked={ctgyForm[k].active === 1 ? true : false} onClick={(e) => handleInputCategory (e, v.id, k, '')}/>
                                <Box>{v.active === 1 ? 'Active' : 'Inactive'}</Box>
                            </Box>
                        }
                    </Box>
                </Box>
            </Box>
        ))
    )
}